import { Stack } from '@mui/material';
import { InboxStubSvg } from '@schooly/style';
import React, { FC, ReactNode } from 'react';

type EmptyInboxProps = {
  title: ReactNode;
  size?: 'medium' | 'large';
};

export const EmptyInbox: FC<EmptyInboxProps> = ({ title, size = 'medium' }) => {
  return (
    <Stack
      flex={1}
      alignItems="center"
      justifyContent="center"
      gap={5}
      sx={{ ...(size === 'large' && { '& svg': { width: 134, height: 134 } }) }}
    >
      <InboxStubSvg />
      {title}
    </Stack>
  );
};
